window.addEventListener('load', function () {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      if (targetId === '#manage-cookies') {
        tarteaucitron.userInterface.openPanel();
      } else {
        scrollIntoView(targetId);
      }
    });
	});

  function scrollIntoView(targetId){
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
      setTimeout(function(){
       targetElement.focus();
      }, 400);
    }
  }

});